import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./Footer.css";
import logoImg from "../../assets/logo.jpeg";
import { CONTACT } from "../../constants/contact";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company info */}
          <div className="footer-col footer-company">
            <div className="footer-logo">
              <img
                src={logoImg}
                alt="FastExpress"
                className="footer-logo-img"
              />
            </div>
            <p className="footer-desc">
              {t("footer.desc")}
            </p>
            <div className="footer-social">
              <a
                href="https://facebook.com"
                className="social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="currentColor"
                >
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                </svg>
              </a>
              <a
                href="https://tiktok.com"
                className="social-link"
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="currentColor"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.68v13.67a2.4 2.4 0 0 1-2.4 2.4 2.4 2.4 0 0 1-2.4-2.4 2.4 2.4 0 0 1 2.4-2.4c.34 0 .67.05.98.15V9.41a5.8 5.8 0 0 0-.98-.08 5.78 5.78 0 0 0-5.78 5.78 5.78 5.78 0 0 0 5.78 5.78 5.73 5.73 0 0 0 5.78-5.78v-3.03a7.28 7.28 0 0 0 3.77 1.04V9.71a4.83 4.83 0 0 1-3.77-3.02z" />
                </svg>
              </a>
              <a
                href="https://instagram.com"
                className="social-link"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="currentColor"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>{t("footer.servicesTitle")}</h4>
            <ul>
              <li>
                <Link to="/services">{t("services.express.title")}</Link>
              </li>
              <li>
                <Link to="/services">{t("services.sea.title")}</Link>
              </li>
              <li>
                <Link to="/services">{t("services.personal.title")}</Link>
              </li>
              <li>
                <Link to="/services">{t("services.customs.title")}</Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="footer-col">
            <h4>{t("footer.supportTitle")}</h4>
            <ul>
              <li>
                <Link to="/tracking">{t("footer.trackOrder")}</Link>
              </li>
              <li>
                <Link to="/pricing">{t("footer.pricingList")}</Link>
              </li>
              <li>
                <a href="/faq">{t("footer.faq")}</a>
              </li>
              <li>
                <a href="/prohibited">{t("footer.prohibited")}</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>{t("footer.contactTitle")}</h4>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="#e85d2a">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                </svg>
                <span>{t("contact.address")}</span>
              </div>
              <div className="footer-contact-item">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="#e85d2a">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.01-.24c1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.1.31.03.66-.25 1.02l-2.2 2.2z" />
                </svg>
                <span>
                  <a href={`tel:${CONTACT.phone}`}>{CONTACT.phoneDisplay}</a>
                </span>
              </div>
              <div className="footer-contact-item">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="#e85d2a">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                <span><a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></span>
              </div>
              <div className="footer-contact-item">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="#e85d2a">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                </svg>
                <span>{t("contact.workingHours")}</span>
              </div>
              <div className="footer-contact-item">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="#e85d2a">
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                </svg>
                <span>{t("footer.workingHours")}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
